import { DatePicker, Form, Input, InputNumber, App, Modal } from 'antd';
import React, { useState, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom';
import { useShangpingdingdanAddMutation } from '../../store/ReactWebSiteApi';
import GetWebGoods from '../goods/GetWebGoods';
import GetWebGoodsSpec from '../goodsSpec/GetWebGoodsSpec';
import ClientSelect from '../client/ClientSelect';
import dayjs from 'dayjs';
import MyEditor from '../../cpn/MyEditor';
import {PlusSquareOutlined} from '@ant-design/icons';
import WebGoodsTypeSelect from '../goodsType/WebGoodsTypeSelect';
import SonTypeSelect from '../goodsType/SonTypeSelect';
function WebGoodsOrderAdd(props) {
    const location = useLocation();
    const editForm = useRef();
    const {message} = App.useApp()
    const [open,setOpen] = useState(false)
    const [form] = Form.useForm();
    const [info,setInfo] = useState({
        eowgt_content:'',
        dd_eowg_id: props.eowg_id || '',
        dd_eowgg_id: props.eowgg_id || '',
        dd_qy_name: props.eowgg_name || props.eowg_name || '',
    });
    const [submitAdd] = useShangpingdingdanAddMutation()

    // 从官网商品详情「立即订购」跳转时自动打开并预填
    useEffect(() => {
        const s = location.state;
        if (s?.fromGoodsDesc && s.eowg_id && s.eowgg_id) {
            setOpen(true);
            setInfo((prev) => ({
                ...prev,
                dd_eowg_id: s.eowg_id,
                dd_eowgg_id: s.eowgg_id,
                dd_qy_name: s.eowgg_name || s.eowg_name || prev.dd_qy_name,
            }));
        }
    }, [location.state]);

    useEffect(() => {
        const s = location.state;
        if (open && s?.fromGoodsDesc && s.eowg_id && s.eowgg_id) {
            form.setFieldsValue({
                dd_eowg_id: s.eowg_id,
                dd_eowgg_id: s.eowgg_id,
            });
        }
    }, [open, location.state, form]);

    // 当组件初始化时，如果有默认的商品规格名称，设置企业名称
    useEffect(() => {
        if (props.eowgg_name) {
            setInfo(prevState => ({
                ...prevState,
                dd_qy_name: props.eowgg_name
            }));
        }
    }, [props.eowgg_name]);
    
    // 调试用：监听企业名称的变化
    useEffect(() => {
        console.log('企业名称变化:', info.dd_qy_name);
    }, [info.dd_qy_name]);
    
    // 当组件挂载时，如果有默认的商品和规格ID，手动设置状态
    useEffect(() => {
        if (props.eowg_id && props.eowgg_id && editForm.current) {
            editForm.current.setFieldsValue({
                dd_eowg_id: props.eowg_id,
                dd_eowgg_id: props.eowgg_id,
                dd_qy_name: props.eowgg_name || props.eowg_name || ''
            });
            setInfo(prevState => ({
                ...prevState,
                dd_eowg_id: props.eowg_id,
                dd_eowgg_id: props.eowgg_id,
                dd_qy_name: props.eowgg_name || props.eowg_name || ''
            }));
        }
    }, [props.eowg_id, props.eowgg_id, props.eowgg_name, props.eowg_name, open]);
    
    return (
        <>
            <a onClick={() => {setOpen(true)}}><PlusSquareOutlined /> 新增订单</a>
            <Modal
                open={open}
                width={800}
                onCancel={() => {setOpen(false)}}
                onOk={() => {
                    form.resetFields();  
                    submitAdd({
                        'dd_eowgt_id': info.dd_eowgt_id,
                        'dd_eowgt_name': info.dd_eowgt_name,
                        'dd_eowgts_id': info.dd_eowgts_id,
                        'dd_eowgts_name': info.dd_eowgts_name,
                        'dd_eowg_id': info.dd_eowg_id,
                        'dd_eowg_name': info.dd_eowg_name,
                        'dd_eowgg_id': info.dd_eowgg_id,
                        'dd_eowgg_name': info.dd_eowgg_name,
                        'dd_byxkh_id': info.dd_byxkh_id,
                        'dd_byxkh_name': info.dd_byxkh_name,
                        'dd_xf_date': info.dd_xf_date,
                        'dd_dq_date': info.dd_dq_date,
                        'dd_xf_amount': info.dd_xf_amount,
                        'dd_xf_num': info.dd_xf_num,
                        'dd_qy_id': info.dd_qy_id,
                        'dd_qy_name': info.dd_qy_name,
                        'dd_content': info.dd_content,
                        'dd_database': info.dd_database,
                        'dd_uid': localStorage.getItem('eu_id'),
                        'dd_uname': localStorage.getItem('eu_name'),
                    }).then((res) => {
                        if (res.data.Status === 'success') {
                            message.success('新增成功！')  
                            setOpen(false)
                            form.resetFields();      
                        }
                        if (res.data.Status === 'fail') {
                            message.error('新增失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client"
                    initialValues={{
                        modifier: 'public',
                    }}
                    labelCol={{ span: 3}}     
                    ref={editForm}
                >   
                    <WebGoodsTypeSelect
                        label='商品类型'
                        onChange={(e,f) => {
                            setInfo(prevState=>({...prevState,dd_eowgt_id:e,dd_eowgt_name:f}))
                        }}
                        wrapperCol={{span:10}} 
                        required
                        name='dd_eowg_type_id'

                    />
                    <SonTypeSelect
                        label='系统名称'
                        onChange={(e,f) => {
                            setInfo(prevState=>({...prevState,dd_eowgts_id:e,dd_eowgts_name:f}))
                        }}
                        wrapperCol={{span:10}} 
                        required
                        name='dd_eowgts_id'
                        eowgt_id={info.dd_eowgt_id}
                    />
                    <GetWebGoods
                        label='商品'
                        placeholder="请选择商品"
                        onChange={(e,f) => {
                            setInfo(prevState=>({...prevState,dd_eowg_id:e,dd_eowg_name:f}))
                        }}
                        wrapperCol={{span:10}} 
                        required
                        name='dd_eowg_id'
                        eowgt_id={info.dd_eowgt_id}
                        eowgts_id={info.dd_eowgts_id}
                    />
                    <GetWebGoodsSpec
                        label='商品规格'
                        placeholder="请选择商品规格"
                        onChange={(e,f) => {
                            setInfo(prevState=>({
                                ...prevState,
                                dd_eowgg_id:e,
                                dd_eowgg_name:f,
                                dd_qy_name: f || prevState.dd_qy_name
                            }))
                        }}
                        wrapperCol={{span:10}} 
                        required
                        eowgg_eowg_id={info.dd_eowg_id || props.eowg_id}
                        name='dd_eowgg_id'
                    />
                    <ClientSelect
                        label='客户'
                        placeholder="请选择客户"
                        onChange={(e,f) => {
                            setInfo(prevState=>{
                                return {
                                    ...prevState,
                                    dd_byxkh_id:e,
                                    dd_byxkh_name:f,
                                    dd_qy_id:e,
                                    dd_qy_name: f
                                };
                            })
                        }}
                        wrapperCol={{span:10}} 
                        required
                        name='dd_byxkh_id'
                    />
                    <Form.Item name="dd_xf_date" label='缴费日期' wrapperCol={{span:10}} required>
                        <DatePicker
                            placeholder="请选择缴费日期"
                            onChange={(e) => {setInfo(prevState=>({...prevState,dd_xf_date:dayjs(e).format('YYYY-MM-DD')}))}}
                        />
                    </Form.Item>
                    <Form.Item name="dd_dq_date" label='到期日期' wrapperCol={{span:10}} required>
                        <DatePicker
                            placeholder="请选择到期日期"
                            onChange={(e) => {setInfo(prevState=>({...prevState,dd_dq_date:dayjs(e).format('YYYY-MM-DD')}))}}
                        />
                    </Form.Item>
                    <Form.Item name="dd_xf_amount" label='缴费金额' wrapperCol={{span:10}} required>
                        <InputNumber 
                            placeholder="请输入缴费金额"
                            onChange={(e) => {setInfo(prevState=>({...prevState,dd_xf_amount:e}))}}
                        />
                    </Form.Item>
                    <Form.Item name="dd_xf_num" label='用户数' wrapperCol={{span:10}} required>
                        <InputNumber 
                            placeholder="请输入用户数量"
                            onChange={(e) => {setInfo(prevState=>({...prevState,dd_xf_num:e}))}}
                        />
                    </Form.Item>
                    <Form.Item name="dd_qy_id" label='企业id' wrapperCol={{span:10}} required>
                        <Input 
                            placeholder="请输入企业ID"
                            onChange={(e) => {setInfo(prevState=>({...prevState,dd_qy_id:e.target.value}))}}
                        />
                    </Form.Item>
                    <Form.Item label='企业名称' wrapperCol={{span:10}} required>
                        <Input  
                            placeholder="请输入企业名称"
                            value={info.dd_qy_name || ''}
                            onChange={(e) => {setInfo(prevState=>({...prevState,dd_qy_name:e.target.value}))}} 
                        />
                    </Form.Item>
                    <Form.Item name="dd_database" label='数据库' wrapperCol={{span:10}} required>   
                        <Input  onChange={(e) => {setInfo(prevState=>({...prevState,dd_database:e.target.value}))}}/>
                    </Form.Item>
                    <Form.Item name="dd_content" label='备注' wrapperCol={{span:10}}>
                        <MyEditor  onChange={(e) => {setInfo(prevState=>({...prevState,dd_content:e}))}}/>
                    </Form.Item>                  
                </Form>
            </Modal>
        </>
    )
}

export default WebGoodsOrderAdd